import type {
    IncomeSplitConfig,
    IncomeSplitRule,
    PaycheckRoutingRuleAccountMetadata,
} from '@fruitful/income-split';
import { useEffect, useState } from 'react';

import { requestBuilder } from '../../../../http/RequestBuilder';

const useGetIncomeSplitConfigs = requestBuilder.query<IncomeSplitConfig[]>({
    endpoint: () => '/api/income-split/list',
    queryKey: () => 'getIncomeConfigs',
});

const useGetExistingIncomeSplitConfigs = () => {
    const [transformedIncomeSplitConfigs, setTransformedIncomeSplitConfigs] =
        useState<IncomeSplitConfig[]>([]);

    const {
        data: incomeSplitConfigs,
        isLoading,
        refetch,
    } = useGetIncomeSplitConfigs({});

    useEffect(() => {
        const transformRule = (rule: IncomeSplitRule): IncomeSplitRule => {
            const { accountMetadata } = rule as IncomeSplitRule & {
                accountMetadata?: PaycheckRoutingRuleAccountMetadata;
            };
            const transformedRule: IncomeSplitRule & {
                accountMetadata?: PaycheckRoutingRuleAccountMetadata;
            } = {
                ...rule,
                percentage: parseFloat(
                    ((rule?.percentage ?? 0) * 100).toFixed(0),
                ),
                accountMetadata,
            };
            return transformedRule;
        };

        const transformedConfigs = (incomeSplitConfigs ?? []).map((config) => {
            return {
                ...config,
                ruleSets: config?.ruleSets?.map((group) => ({
                    ...group,
                    rules: group.rules
                        .map(transformRule)
                        .sort((a, b) => a.priority - b.priority),
                })),
            };
        });
        setTransformedIncomeSplitConfigs(transformedConfigs);
    }, [incomeSplitConfigs]);

    return {
        incomeSplitConfigs: transformedIncomeSplitConfigs,
        isLoading,
        refetch,
    };
};

export default useGetExistingIncomeSplitConfigs;
